import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import "./components/global/primary.css";
import "./components/global/grid.css";
import ErrorComponent from "./components/ErrorComponent/ErrorComponent";
import AgentGrc from "./pages/AgentGRC";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AgentGrc />} />
        <Route path="*" element={<ErrorComponent />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
